module.exports = __webpack_public_path__ + "assets/imgs/logos/joom.048d84dc144cfb57428d3310869a5faf.svg";